export { default } from './BalanceAndAllocationTabPanelLayout';
